"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVideoObjectWithContext = exports.getVideoCarouselWithContext = exports.duration = exports.uploadDateMs = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const duration_1 = __importDefault(require("dayjs/plugin/duration"));
dayjs_1.default.extend(duration_1.default);
const ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029",
};
const ESCAPE_REGEX = /[&><\u2028\u2029]/g;
// based on https://github.com/zertosh/htmlescape
// license: https://github.com/zertosh/htmlescape/blob/0527ca7156a524d256101bb310a9f970f63078ad/LICENSE
const htmlEscapeJsonString = (str) => str.replace(ESCAPE_REGEX, (match) => ESCAPE_LOOKUP[match]);
const interactionStatistic = (videoMetadata) => {
    const interactionStatistic = [];
    if (videoMetadata.viewCount) {
        interactionStatistic.push({
            "@type": "InteractionCounter",
            interactionType: {
                "@type": "WatchAction",
            },
            userInteractionCount: parseInt(videoMetadata.viewCount, 10),
        });
    }
    if (videoMetadata.shareCount) {
        interactionStatistic.push({
            "@type": "InteractionCounter",
            interactionType: {
                "@type": "ShareAction",
            },
            userInteractionCount: parseInt(videoMetadata.shareCount, 10),
        });
    }
    return { interactionStatistic };
};
const creator = (videoMetadata) => {
    if (videoMetadata.creator?.$case === "personCreator") {
        const personCreator = videoMetadata.creator.personCreator;
        return {
            creator: {
                "@type": "Person",
                alternateName: personCreator.username,
                url: personCreator.url,
                name: personCreator.name,
            },
        };
    }
    else {
        return {};
    }
};
const uploadDateMs = (videoMetadata) => {
    if (videoMetadata.uploadDateMs === "0") {
        return;
    }
    return new Date(parseInt(videoMetadata.uploadDateMs, 10)).toISOString();
};
exports.uploadDateMs = uploadDateMs;
const duration = (videoMetadata) => {
    if (videoMetadata.durationMs === "0") {
        return {};
    }
    return {
        duration: dayjs_1.default.duration(parseInt(videoMetadata.durationMs, 10), "ms").toISOString(),
    };
};
exports.duration = duration;
const dimensions = (videoMetadata) => {
    if (videoMetadata.width && videoMetadata.height) {
        return {
            width: `${videoMetadata.width} px`,
            height: `${videoMetadata.height} px`,
        };
    }
    else {
        return {};
    }
};
const getVideoObject = (videoMetadata, index) => {
    const { name, description, thumbnailUrl, contentUrl, keywords } = videoMetadata;
    const uploadDate = (0, exports.uploadDateMs)(videoMetadata);
    if (!name || !thumbnailUrl || !uploadDate) {
        return;
    }
    const videoObject = {
        "@type": "VideoObject",
        name,
        description,
        thumbnailUrl,
        uploadDate,
        ...interactionStatistic(videoMetadata),
        contentUrl,
        ...creator(videoMetadata),
        ...(0, exports.duration)(videoMetadata),
        ...dimensions(videoMetadata),
        encodingFormat: "video/mp4",
        isFamilyFriendly: true,
        ...(keywords.length > 0 && {
            keywords: keywords.join(","),
        }),
    };
    if (typeof index === "number") {
        const extendedVideoObject = {
            ...videoObject,
            position: index + 1,
        };
        return extendedVideoObject;
    }
    return videoObject;
};
// https://developers.google.com/search/docs/appearance/structured-data/carousel
const getVideoCarouselWithContext = (videoMetadata) => {
    const videoObjects = videoMetadata.map(getVideoObject).filter((obj) => obj !== undefined);
    if (videoObjects.length < 1) {
        return "";
    }
    const videoObjectsString = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "ItemList",
        itemListElement: videoObjects,
    });
    return htmlEscapeJsonString(videoObjectsString);
};
exports.getVideoCarouselWithContext = getVideoCarouselWithContext;
const getVideoObjectWithContext = (videoMetadata) => {
    const videoObject = getVideoObject(videoMetadata);
    if (!videoObject) {
        return "";
    }
    const videoObjectsString = JSON.stringify({
        "@context": "https://schema.org",
        ...videoObject,
    });
    return htmlEscapeJsonString(videoObjectsString);
};
exports.getVideoObjectWithContext = getVideoObjectWithContext;
//# sourceMappingURL=videoObjectUtils.js.map